import React from "react";
import { useDispatch } from "react-redux";

import { IgButton } from "@intelligems/ig-theme";
import {
  DiscountMessageBoxWidget,
  WidgetTypeType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { initializeWidget } from "../../../api/initials";
import { setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { mpClickCreateWidgetButton } from "../../../utils/mixpanel";
import { WidgetDrawer } from "../WidgetDrawer/WidgetDrawer";

import { DiscountMessageBoxWidgetPreview } from "./DiscountMessageBoxWidgetPreview";

interface MessageBoxWidgetsOverviewProps {
  messageBoxWidgets: DiscountMessageBoxWidget[];
  widgetType: WidgetTypeType;
}

export const DiscountMessageBoxWidgetsOverview = ({
  widgetType,
  messageBoxWidgets,
}: MessageBoxWidgetsOverviewProps) => {
  const dispatch = useDispatch();

  const onCreateNew = () => {
    mpClickCreateWidgetButton("messageBoxPopup");
    dispatch(
      setSelectedWidget(
        initializeWidget(
          widgetType,
          widgetType === "messageBoxPopup"
            ? "messageBoxPopupWidget1"
            : "messageBoxSlideOutWidget1"
        ) as DiscountMessageBoxWidget
      )
    );
    dispatch(setDrawer({ drawer: "widgetAction", open: true }));
  };

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid item>
        <IgButton
          variant={"contained"}
          onClick={() => {
            onCreateNew();
          }}
        >
          {widgetType === "messageBoxPopup"
            ? "Create Pop Up"
            : "Create Slide Out"}
        </IgButton>
      </Grid>
      <Grid item container direction={"row"} rowSpacing={2} columnSpacing={2}>
        {messageBoxWidgets.map((messageBox, index) => (
          <DiscountMessageBoxWidgetPreview
            key={`message-box-${index}`}
            messageBoxWidget={messageBox}
          />
        ))}
        <WidgetDrawer widgetType={widgetType} buttonFocus={widgetType} />
      </Grid>
    </Grid>
  );
};
